// src/components/ConsultingTrack.js
import React from 'react';
import { FileSearch, Shield, Workflow, FileText, Users, ArrowRight } from 'lucide-react';
import '../styles/ConsultingTrack.css';

const ConsultingTrack = () => {
  const consultingServices = [
    {
      icon: <FileSearch className="consulting-icon" />,
      title: "Architecture Audits",
      description: "Comprehensive review of your current architecture, identifying technical debt, security gaps, and scalability bottlenecks."
    },
    {
      icon: <Shield className="consulting-icon" />,
      title: "Cloud Hardening",
      description: "Azure/AWS security baseline implementation, compliance alignment, and infrastructure vulnerability assessments."
    },
    {
      icon: <Workflow className="consulting-icon" />,
      title: "CI/CD Implementation",
      description: "Automated deployment pipelines, testing frameworks, and release management processes for faster, safer deployments."
    },
    {
      icon: <FileText className="consulting-icon" />,
      title: "Documentation & Runbooks",
      description: "Executive-ready documentation, operational runbooks, and knowledge transfer for your team."
    },
    {
      icon: <Users className="consulting-icon" />,
      title: "Executive Briefings",
      description: "Board-level reporting, risk assessments, and strategic technology roadmap presentations."
    }
  ];

  return (
    <section className="consulting-track-section">
      <div className="consulting-container">
        <div className="consulting-header">
          <span className="consulting-badge">Consulting Services</span>
          <h2 className="consulting-title">
            Architecture & Reliability Consulting
          </h2>
          <p className="consulting-description">
            Strategic guidance and hands-on implementation to elevate your platform's reliability, security, and governance.
          </p>
        </div>

        <div className="consulting-grid">
          {consultingServices.map((service, index) => (
            <div key={index} className="consulting-card">
              <div className="consulting-card-icon-wrapper">
                {service.icon}
              </div>
              <h3 className="consulting-card-title">{service.title}</h3>
              <p className="consulting-card-description">{service.description}</p>
            </div>
          ))}
        </div>

        <div className="consulting-cta-container">
          <div className="consulting-cta-card">
            <div className="consulting-cta-content">
              <h3 className="consulting-cta-title">
                Ready to Assess Your Architecture?
              </h3>
              <p className="consulting-cta-text">
                Get a comprehensive audit of your platform's reliability, security, and scalability.
              </p>
            </div>
            <button className="consulting-cta-button">
              Request Audit
              <ArrowRight className="cta-button-icon" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ConsultingTrack;